import { Injectable } from '@angular/core';
import { constants } from './../utitlity/constant';
import { endpoints } from './../utitlity/endpoints';
import { HttpClientService } from './httpClient.service';

@Injectable()
export class LeadFormService {
    static aelList;
    public leadProductDetails: any;

    constructor(private httpClient: HttpClientService) {
    }

    setLeadProductDetails(leadProductDetails) {
        this.leadProductDetails = leadProductDetails;
    }
    getLeadProductDetails() {
        return this.leadProductDetails;
    }
    getLeadFormPageData(prodCode, isFeedbackForm) {
        let url = constants.isAEM ? endpoints.withAEM.leadFormPage : endpoints.withoutAEM.leadFormPage;

        // GET call
        // let productCodeUrl = url + '?ProductCode=' + prodCode;
        // console.log(productCodeUrl);
        // return this.httpClient.get(productCodeUrl);

        // POST call
        let productCodeUrl = url;
        console.log(productCodeUrl);
        let reqBody = {
            "productCode": prodCode
        }
        return this.httpClient.post(productCodeUrl, reqBody);
    }

    leadFormSubmission(leadFormDetails) {
        // let url = constants.URLs.BASE_URL_DEV + 'productLead';
        let url = constants.URLs.BASE_URL_PROD + 'productLead';
        return this.httpClient.post(url, leadFormDetails);
    }

    accountConversionFormSubmission(accountConversionDetails) {
        let url = constants.URLs.BASE_ARAMEX_URL + '/shipments?journeyType=ntc';
        return this.httpClient.post(url, accountConversionDetails);
    }
    getAel() {
        let getAelUrl = "";
        getAelUrl = constants.isAEM ? endpoints.withAEM.aelAEMContents : endpoints.withoutAEM.aelAEMContents;
        return this.httpClient.get(getAelUrl);
    }
    getAelList() {
        let aelListArray: any = [];
        let promise = new Promise((resolve, reject) => {
            if (LeadFormService.aelList && LeadFormService.aelList.length) {
                resolve(LeadFormService.aelList);

            } else {
                this.getAel().then((data) => {
                    let aelJson = JSON.parse(data.aelInfo);
                    let aelKeys = Object.keys(aelJson);

                    for (let i = 0; i < aelKeys.length; i++) {
                        let aeldata = {
                            code: aelKeys[i],
                            name: aelJson[aelKeys[i]]
                        }
                        aelListArray.push(aeldata);

                    };
                    LeadFormService.aelList = aelListArray
                    resolve(LeadFormService.aelList);
                }, (err) => {
                    reject(err);
                });

            }

        })
        return promise;
    }

    getAccountConversionFormData() {
        let reqBody = {
            "productCode": 'CN1'
        }
        let url = constants.isAEM ? endpoints.withAEM.accountConversionForm : endpoints.withoutAEM.accountConversionForm;
        return constants.isAEM ? this.httpClient.post(url, reqBody) : this.httpClient.get(url);

    }
    getPOAFormData() {
        let reqBody = {
            "productCode": 'POA'
        }
        let url = constants.isAEM ? endpoints.withAEM.poaForm : endpoints.withoutAEM.poaForm;
        return constants.isAEM ? this.httpClient.post(url, reqBody) : this.httpClient.get(url);

    }
    
    getTaxFormData() {
        let reqBody = {
            "productCode": 'TAX'
        }
        let url = constants.isAEM ? endpoints.withAEM.taxInfoForm : endpoints.withoutAEM.taxInfoForm;
        return constants.isAEM ? this.httpClient.post(url, reqBody) : this.httpClient.get(url);

    }

    getFatcaFormData() {
        let reqBody = {
            "productCode": 'FATCA'
        }
        let url = constants.isAEM ? endpoints.withAEM.fatcaForm : endpoints.withoutAEM.fatcaForm;
        return constants.isAEM ? this.httpClient.post(url, reqBody) : this.httpClient.get(url);

    }

    retrieveToken(arn) {
        let url = constants.URLs.newEndpoint + "/retrieveToken/" + arn;
        return this.httpClient.get(url);
    }

    poaFormSubmission(poaDetails) {
        let url = constants.URLs.BASE_ARAMEX_URL + '/create-queue-poa';
        return this.httpClient.post(url, poaDetails);

    }

    getDocumentList() {
        let url = endpoints.withoutAEM.documentList;
        return  this.httpClient.get(url);
      }
      
      getARN() {
        let url = constants.URLs.newEndpoint + '/arn';
        return this.httpClient.get(url)
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/services/lead-form.service.ts